/**
 * Sets the property on an object using dot notation
 * e.g. `setPropertyFromDotNotation({}, 'sandwhich.bacon', true);`
 * ```
 * {
 *  sandwhich: {
 *      bacon: true
 *  }
 * }
 * ```
 *
 * @param obj - The object
 * @param dotPath - The dot notation path
 * @param value - The value
 * @returns The updated object
 */
export function setPropertyFromDotNotation<T extends Record<string, unknown>>(
    obj: T,
    dotPath: string,
    value: unknown,
): T {
    const pathArray = dotPath.split('.');
    const length = pathArray.length;

    let index = 0;
    const lastIndex = length - 1;
    let nested: any = obj;

    while (nested !== null && index < length) {
        const key = pathArray[index];
        nested[key] = index === lastIndex ? value : (nested[key] ?? {});
        nested = nested[key];

        index++;
    }

    return obj;
}
